// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import MultiUnitTitle from './MultiUnitTitle';

type Props = {
    propertyName: string,
    resultCount?: number,
    loading: boolean
};

export default function MultiUnitTypesSummary(props: Props) {
    const {propertyName, resultCount, loading} = props;

    return (
        <div className="MultiUnitDropdown__header micro">
            <MultiUnitTitle headline={propertyName} />
            {loading && (
                <div className="MultiUnitDropdown__header-row--loading">
                    <div className="MultiUnit__header-skeleton" />
                </div>
            )}

            {!!resultCount &&
                resultCount > 0 && (
                    <FormattedMessage
                        id="unitsAvailableText"
                        defaultMessage="Available units"
                    >
                        {(txt) => (
                            <span className="MultiUnitDropdown__header_resultcount">
                                {txt} {resultCount}
                            </span>
                        )}
                    </FormattedMessage>
                )}
        </div>
    );
}
